<template>
  <div class="section grid-view">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button
              no="new"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              no="edit"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>
            <el-button no="delete" :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Partners.specialRequirements')">
            <el-input v-model="editDialog.form.request" no="request" />
          </el-form-item>
          <el-form-item :label="$t('Payment.businessType')">
            <el-select v-model="editDialog.form.lob" no="lob">
              <el-option
                v-for="(item,index) in lobSource"
                :key="index"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Payment.remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="tempSave">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { AutoIncrementNum } from '@/utils/commonUtil'
import { getSpecialRequestList } from '@/api/partner/specialRequest'

export default {
  name: 'SpecialRequestForm',
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      lobSource: [],
      lobMap: new Map(),
      filter: {
        customerUuid: ''
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Partners.specialRequirements'),
          field: 'request',
          width: 200
        }, {
          headerName: this.$t('Payment.businessType'),
          field: 'lob',
          width: 200,
          valueFormatter: params => {
            return this.lobMap.get(params.value) || ''
          }
        }, {
          headerName: this.$t('Payment.remarks'),
          field: 'remarks',
          width: 200
        }
      ],
      rowData: [],
      deletedSpecialRequestKeys: [],
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          request: '',
          lob: '',
          remarks: '',
          customerUuid: ''
        }
      },
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    }
  },
  created() {
    const lobSource = this.$constantI18n('lobSource').filter(p => p.value !== 'RE')
    this.lobSource = [{ name: this.$t('SeaExport.All'), value: 'ALL' }, ...lobSource]
    for (const item of this.lobSource) {
      this.lobMap.set(item.value, item.name)
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.filter.customerUuid = row.customerDetail.uuid
        if (this.filter.customerUuid) {
          this.toQuery()
        } else {
          this.rowData = []
          this.deletedSpecialRequestKeys = []
        }
      }
    },
    toQuery() {
      const filter = this.filter
      getSpecialRequestList(filter).then(res => {
        for (const item of res.data) {
          item.seq = this.autoIncrementNum.getNextNum()
        }
        this.rowData = res.data
        this.deletedSpecialRequestKeys = []
      })
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          request: '',
          lob: '',
          remarks: '',
          customerUuid: this.filter.customerUuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.rowData[cell.rowIndex] : null
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    getSubmitData() {
      return {
        specialRequests: this.rowData,
        deletedSpecialRequestKeys: this.deletedSpecialRequestKeys
      }
    },
    tempSave() {
      const self = this
      const form = self.editDialog.form
      const oldRow = this.rowData.find(p => p.seq === form.seq)
      if (oldRow) {
        Object.assign(oldRow, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      self.editDialog.visible = false
    },
    remove() {
      const self = this
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (!row) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        this.rowData.splice(index, 1)
        if (row.uuid) {
          this.deletedSpecialRequestKeys.push(row.uuid)
        }
      }).catch(() => { })
    }
  }
}
</script>

<style scoped lang="scss">
.grid-view {
  &.section {
    padding: 10px 20px;
  }
}
</style>
